import { string, object, ref, number } from 'yup';
import * as Yup from 'yup';
export const CURRENT_PAGE = 1;
export const PER_PAGE = 25;

export const ROUTES = {
    LIST_USER: `/api/v1/list/user`,
    LIST_ACTIVE_USER: `/api/v1/list/active/user`,
    LIST_PENDING_USER: `/api/v1/pending/list/user`,
    LIST_SINGLE_USER: (id) => `/api/v1/view/user/${id}`,
    LIST_ROLES: `/api/v1/roles`,
    CREATE_USER: `/api/v1/user/onboard`,
    EDIT_USER: (id) => `/api/v1/update/user/${id}`,
    UPDATE_STATUS: (id) => `/api/v1/change/user/status/${id}`,
    UPDATE_PENDING_STATUS: (id) => `/api/v1/approve/user/${id}`,
    UPDATE_PASSWORD: (id) => `/api/v1/update/password/${id}`,
    ASSIGNED_CLIENTS: (id) => `/api/v1/view/user/clients/${id}`,
    UNASSIGNED_CLIENTS: (id) => `/api/v1/client/unassigned/list/${id}`,
    ASSIGN_CLIENT: (id) => `/api/v1/assign/bulk/client/${id}`,
    REMOVE_CLIENT: (id) => `/api/v1/remove/user/client/${id}`
}

export const USER_SCHEMA = (isUpdate) =>
    Yup.object().shape({
        name: Yup.string()
            .required("Name is required")
            .matches(/^[A-Za-z\s]+$/, "Only alphabets and spaces are allowed."),

        phone: Yup.string()
            .notRequired()
            .nullable()
            .test("is-valid-phone", "Phone number must be exactly 10 digits", function (value) {
                if (!value) return true; 
                return /^\d{10}$/.test(value); 
            }),

        email: Yup.string()
            .email("Invalid email format")
            .required("Email is required"),

        user_role: Yup.string()
    });

export const ROLE_PERMISSIONS = {
    can_staff_add: 'Add Staff',
    can_change_staff: 'Edd Staff',
    can_view_staff: 'View Staff',
    can_disable_staff: 'Activate/Deactivate Staff',
    can_assign_client: 'Assign Client',
    can_add_client: 'Add Client',
    can_change_client: 'Edit Client',
    can_delete_client: 'Delete Client',
    can_view_client: 'View CLient',
    can_create_period: 'Add Period',
    can_change_period: 'Edit Period',
    can_view_period: 'View Period',
    can_delete_period: 'Delete Period',
    can_upload_files: 'Upload files',
    can_manage_all_clients: 'Manage all clients'

}

export const PAGE_PERMISSIONS = {
    user: ['can_staff_add', 'can_change_staff', 'can_view_staff', 'can_disable_staff', 'can_assign_client'],
    client: ['can_create_client', 'can_update_client', 'can_delete_client', 'can_view_client', 'can_approve_client'],
    period: ['can_add_folders', 'can_change_period', 'can_view_period', 'can_delete_period'],
    files: ['can_view_file', 'can_file_download'],
    hsn: ['can_view_hsn', 'can_view_enquiry'],
    rbac: ['can_view_hierarchy', 'can_view_roles'],
    department: ['can_view_department'],
    gstr1: ['can_view_gstr1'],
    gstr3b: ['can_view_gstr3b'],
    refund: ['can_view_refund'],
    gstr9: ['can_view_gstr9'],
    gstr9c: ['can_view_gstr9C'],
    litigation: ['can_view_litigation'],
    facilitation: ['can_view_facilitation'],
    forex: ['add_currency'],
    user_management: ['can_staff_add', 'can_change_staff', 'can_view_staff', 'can_disable_staff', 'can_assign_client', 'can_view_hierarchy', 'can_view_roles'],
    reconciliation: ['delete_uploadedfiles','view_uploadedfiles','add_uploadedfiles']

}

export const CRUD_PERMISSIONS = {
    user: {
        add: ['can_staff_add', 'add_user'],
        edit: ['can_change_staff'],
        delete: ['can_change_staff'],
        assign: ['can_assign_client']
    },
    client: {
        add: ['can_create_client',],
        edit: ['can_update_client'],
        delete: ['can_delete_client'],
        approve: ['can_approve_client']
    },
    period: {
        add: ['can_add_folders',],
        edit: ['can_change_period'],
        delete: ['can_delete_period']
    },
    files: {
        upload_files: ['can_upload_files'],
        view_files: ['can_view_file'],
        download_files: ['can_file_download'],
    },
    sheet: {
        manage_clients: ['can_manage_all_clients']
    },
    common_approval: {
        user_onboard: ['can_set_approval_staff'],
        client_onboard: ['can_set_approval'],
        hsn_approval: ['can_set_hsn_approval'],
    },
    hsn: {
        add: ['can_add_hsn_repo'],
        edit: ['can_edit_hsn_repo'],
    },
    rbac: {
        set_heirarchy: ['can_set_hierarchy'],
        create_role: ['can_create_role'],
    },
    department: {
        add: ['can_create_department'],
        edit: ['can_update_department'],
        assign: ['can_assign_department'],
    },
    gstr1: {
        upload: ['can_upload_gstr1'],
        delete: ['can_delete_gstr1'],
        comment: ['can_comment_gsrt1'],
        approve: ['can_approve_gsrt1'],
        download: ['can_download_gstr1'],
    },
    gstr3b: {
        upload: ['can_upload_gstr3b'],
        delete: ['can_delete_gstr3b'],
        comment: ['can_comment_gstr3b'],
        approve: ['can_approve_gstr3b'],
        download: ['can_download_gstr3b'],
    },
    refund: {
        upload: ['can_upload_refund'],
        delete: ['can_delete_refund'],
        comment: ['can_comment_refund'],
        approve: ['can_approve_refund'],
        download: ['can_download_refund'],
        arn: ['can_add_arn'],
    },
    gstr9: {
        upload: ['can_upload_gstr9'],
        delete: ['can_delete_gstr9'],
        comment: ['can_comment_gstr9'],
        approve: ['can_approve_gstr9'],
        download: ['can_download_gstr9'],
    },
    gstr9c: {
        upload: ['can_upload_gstr9C'],
        delete: ['can_delete_gstr9C'],
        comment: ['can_comment_gstr9C'],
        approve: ['can_approve_gstr9C'],
        download: ['can_download_gstr9C'],
    },
    litigation: {
        add: ['can_create_litigation'],
        update: ['can_update_litigation'],
        delete: ['can_delete_litigation'],
    },
    facilitation: {
        add: ['can_create_facilitaion'],
        update: ['can_update_facilitaion'],
    },
    forex: {
        add: ['add_currency']
    },
    reconciliation: {
        approve: ['process_subsidy_approval'],
    },
}
export const USER_ROLES = {
    admin: 1,
    manager: 2,
    senior_associate: 3,
    associate: 4
}

export const RESTRICT_ASSIGN_ROLES = [1]